import React, {Component} from 'react';
import {Card} from 'semantic-ui-react';
import PlanData from "../../data/PlanData";
import PlanCard from "./PlanCard";

class Plans extends Component {

    constructor() {
        super();
        this.state = {
            plans: []
        };

        this.selectedPlan = this.selectedPlan.bind(this);
    }

    componentDidMount(){
        this.initialFetch();
    }

    async initialFetch(){
        let plans = await PlanData.list();
        this.setState({plans});
    }

    selectedPlan(plan){
        this.props.callbackSelectPlan(plan);
    }

    render() {

        let plans = this.state.plans.map(function(plan) {
            return (
                <PlanCard plan={plan} key={plan.id} callbackSelected={this.selectedPlan}/>
            )
        }, this);

        return (
            <div>
                <Card.Group doubling stackable itemsPerRow={4}>
                    {plans}
                </Card.Group>
            </div>
        );
    }
}
export default Plans;



// WEBPACK FOOTER //
// ./src/components/settings/Plans.js